import { Subject, fromEvent } from "rxjs";
import { filter, map } from "rxjs/operators";

import { ALL, APP_LOADED, SEND_CACHED_STARTUP_EVENTS } from "./messageTypes";

export function isBrowser() {
  return window.device && window.device.platform === "browser";
}

let messagesToWebAppSubject;
function getMessageToWebAppSubject() {
  if (!messagesToWebAppSubject) {
    messagesToWebAppSubject = new Subject();
  }
  return messagesToWebAppSubject;
}

export function onMessageToWebApp(messageType = ALL, handler) {
  const messagesToWebApp = getMessageToWebAppSubject();
  const applicableMessages =
    messageType === ALL
      ? messagesToWebApp
      : messagesToWebApp.pipe(filter(eventData => eventData && eventData.type === messageType));

  applicableMessages.subscribe(handler);
}

let appHasLoaded = false;
let messagesBeforeAppLoaded = [];
export function sendMessageToWebApp(messageType, message) {
  if (appHasLoaded) {
    getMessageToWebAppSubject().next({ type: messageType, ...message });
  } else {
    messagesBeforeAppLoaded.push({ messageType, message });
  }
}

// Set up watchers for messages from app
let messagesFromWebApp;
export function onMessageFromWebApp(messageType = ALL, handler) {
  if (!messagesFromWebApp) {
    // start listening to messages from web app
    const messages = fromEvent(window, "message");
    messagesFromWebApp = messages.pipe(
      filter(event => event.origin === process.env.VUE_APP_DOMAIN),
      map(event => event.data)
    );
  }

  const applicableMessages =
    messageType === ALL
      ? messagesFromWebApp
      : messagesFromWebApp.pipe(filter(eventData => eventData && eventData.type === messageType));

  applicableMessages.subscribe(handler);
}

// Listen for any events that happened before the app loaded
const appLoadedListener = onMessageFromWebApp(APP_LOADED, () => {
  appHasLoaded = true;
  appLoadedListener.unsubscribe();
});

// after the app has loaded, wait for an event signaling that the client has set up
// listeners to recieve the cached startup events.  Once we get this signal, send the
// events that were cached
const sendCachedStartupEventsListener = onMessageFromWebApp(SEND_CACHED_STARTUP_EVENTS, () => {
  messagesBeforeAppLoaded.forEach(({ messageType, message }) => {
    sendMessageToWebApp(messageType, message);
  });
  sendCachedStartupEventsListener.unsubscribe();
  messagesBeforeAppLoaded = [];
});
